import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../baseClasses/BaseComponent';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';

import './ProjectListSearch.scss';
import Input from '../../../components/Input';

export class ProjectListSearch extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchString: localStorage.getItem('searchStringProject')?localStorage.getItem('searchStringProject'):'',
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    this.logSearchClicked = this.logSearchClicked.bind(this);
  }

  handleInput(e) {
    this.setState({ searchString: e.target.value });
    if (this.props.handleProjectSearch) {
      localStorage.setItem('searchStringProject',e.target.value);
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      const self = this;
      this.searchTimer = setTimeout(() => {
        self.props.handleProjectSearch(self.state.searchString);
      }, 500);
    }
  }

  logSearchClicked() {
    this.analyticsLogger.logDashboardEvent('ProjectListSearch');
  }

  render() {
    return (
      <div className="project-list-search">
        <div className="project-search-bar">
          <div className="project-search-icon">
          </div>
          <Input className="project-search-input" placeholder="Search Projects" 
          value={this.state.searchString} 
          onChange={this.handleInput} onClick={this.logSearchClicked}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};
export default connect(mapStateToProps)(ProjectListSearch);




// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectsListWrapper/ProjectListSearch/index.js